import { t } from "i18next";
import { MenuRoutePaths } from "models/constants/routes";
import { GoArrowRight } from "react-icons/go";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardCard from "widgets/cards/dashboard";
import CircleButton from "widgets/controls/buttons/circle-button";
import { DashCounts } from "./Issues";
import { setIssuesPageFilters } from "store/page/pageSlice";
import { getIssuesListFilters } from "store/page/pageSelectors";

interface GeneralProps {
  count?: number;
  metrics?: DashCounts;
  color:
    | "50"
    | "100"
    | "200"
    | "300"
    | "400"
    | "500"
    | "600"
    | "700"
    | "800"
    | "900";
  textColor?: "primary" | "secondary" | "tertiary" | "white";
  extra?: string;
  context: string;
}

const Generic: React.FC<GeneralProps> = ({
  count = 0,
  metrics,
  color = "900",
  textColor = "primary",
  extra = "h-full",
  context,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const defaultFilters = useSelector(getIssuesListFilters, shallowEqual);

  // Map semantic color names to Tailwind classes
  const getTextColorClass = (color: string) => {
    switch (color) {
      case "primary":
        return "text-primary";
      case "secondary":
        return "text-secondary";
      case "tertiary":
        return "text-tertiary";
      case "white":
        return "text-white";
      default:
        return `text-${color}`;
    }
  };

  const handleRoute = () => {
    switch (context) {
      case "total":
        navigate(`/admin${MenuRoutePaths.DEVICES}`);
        break;
      case "users":
        navigate(`/admin${MenuRoutePaths.USERS}`);
        break;
      case "sites":
        navigate(`/admin${MenuRoutePaths.SITES}`);
        break;
      case "zerocount":
        dispatch(
          setIssuesPageFilters({
            ...defaultFilters,
            snrs: metrics?.devices,
            paginationState: {
              ...defaultFilters.paginationState,
              pageIndex: 0,
            },
          })
        );
        navigate(`/admin${MenuRoutePaths.ISSUES}`);
        break;
      case "down":
        dispatch(
          setIssuesPageFilters({
            ...defaultFilters,
            snrs: metrics?.devices,
            paginationState: {
              ...defaultFilters.paginationState,
              pageIndex: 0,
            },
          })
        );
        navigate(`/admin${MenuRoutePaths.ISSUES}`);
        break;
      case "leaking":
        dispatch(
          setIssuesPageFilters({
            ...defaultFilters,
            snrs: metrics?.devices,
            paginationState: {
              ...defaultFilters.paginationState,
              pageIndex: 0,
            },
          })
        );
        navigate(`/admin${MenuRoutePaths.ISSUES}`);
        break;
      case "weaksignal":
        dispatch(
          setIssuesPageFilters({
            ...defaultFilters,
            snrs: metrics?.devices,
            paginationState: {
              ...defaultFilters.paginationState,
              pageIndex: 0,
            },
          })
        );
        navigate(`/admin${MenuRoutePaths.ISSUES}`);
        break;
      default:
        break;
    }
  };

  return (
    <DashboardCard
      title={t("dashboard.card.title", { context })}
      bgColor={color}
      textColor={textColor}
      extra={extra}
    >
      <div className="flex-grow"></div>
      <div
        className={`heading-4xl mb-4 ${getTextColorClass(textColor)} 4xl:mb-0`}
      >
        {count || metrics?.count || 0}
      </div>
      <div className="absolute bottom-4 right-2">
        <CircleButton
          label={t("dashboard.card.action", { context })}
          size="xs"
          variant="ghost"
          color={textColor as any}
          icon={GoArrowRight}
          iconPosition="right"
          onClick={handleRoute}
        />
      </div>
    </DashboardCard>
  );
};

export default Generic;
